import { Flex, SkeletonH5 } from '@npco/zeller-design-system'

import { LoaderList } from 'components/LoaderList'

export const DebitCardTransactionListSkeleton = () => {
  return (
    <>
      <Flex pb="12px">
        <SkeletonH5 width="7.5rem" />
      </Flex>
      <LoaderList />
    </>
  )
}
